import styled from 'styled-components'
import { TableCell as SemanticTableCell } from 'semantic-ui-react'

export const TableCell = styled(SemanticTableCell)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
